export enum PDASettingsConstants {
  GET_PDA_SETTINGS_REQUEST = 'GET_PDA_SETTINGS_REQUEST',
  GET_PDA_SETTINGS_SUCCESS = 'GET_PDA_SETTINGS_SUCCESS',
  GET_PDA_SETTINGS_FAILURE = 'GET_PDA_SETTINGS_FAILURE',
}
